// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-16X-u";
var _4 = "text-3nF9m";
var _5 = "links-1hZWf";
var _6 = "checkbox-34xVF";
var _7 = "active-2P__E";
var _8 = "buttons-Ngw4P";
var _9 = "deleteButton-1DdsV";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "text", _5 as "links", _6 as "checkbox", _7 as "active", _8 as "buttons", _9 as "deleteButton" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "text": _4, "links": _5, "checkbox": _6, "active": _7, "buttons": _8, "deleteButton": _9 }
